export default __webpack_public_path__ + "static/media/pic7.9417c4d1.jpg";